import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { DateView } from "./DateView";

export interface DateViewContainerProps {
    bindingPath: AbsoluteModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: DateViewContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    return {
        value: viewModelSelect.controlModel(state, bindingPath).value,
    };
};

export const DateViewContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps)(withControlDebugInfo(DateView)))
);
